import { UseMutationOptions } from '@tanstack/react-query';

import { CreateVoiceContentInput } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

/**
 * Creates voice content.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useCreateVoiceContent = (mutateOptions: UseMutationOptions<unknown, Error, CreateVoiceContentInput>) =>
    useMutation<CreateVoiceContentInput>(MutationKeys.CREATE_VOICE_CONTENT, CuredApiPaths.VOICE_CONTENT, mutateOptions);

export default useCreateVoiceContent;
